import { render, staticRenderFns } from "./DynamicButton.vue?vue&type=template&id=2ce58adf&"
import script from "./DynamicButton.vue?vue&type=script&lang=js&"
export * from "./DynamicButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports